import { getPathwayStepsByIds } from '@/apis/pathways';
import { isTemplatePlaceholder } from '@/types';
import { RuleProperties } from '@react-awesome-query-builder/mui';
import { PathwayStepsFilter } from '@/types/searchFilterTypes';
import { FilterMapper, ValidationContext } from './filterMapperTypes';
import { AutocompleteGenericEntity } from '@australiangreens/ag-internal-components';

export const PathwayStepsMapper: FilterMapper = {
  checkIsIncomplete({ value }) {
    const isNoStepSelected = value[0].value.length === 0;
    return isNoStepSelected;
  },
  toFilter({ value }: RuleProperties): PathwayStepsFilter {
    if (!value) throw new Error('Missing value');

    if (value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    const nestedValue = value[0].value;
    let mappedValue;
    if (isTemplatePlaceholder(nestedValue)) {
      mappedValue = nestedValue;
    } else {
      const steps = value[0] as { value: AutocompleteGenericEntity[] };

      mappedValue = steps.value.map(({ id }) => {
        return id;
      });
    }

    return { name: 'pathwaySteps', value: mappedValue } as PathwayStepsFilter;
  },

  async fromFilter(filter: PathwayStepsFilter, { token }: ValidationContext) {
    if (isTemplatePlaceholder(filter.value)) {
      return {
        field: filter.name,
        operator: 'any in',
        value: [
          {
            value: filter.value,
            errors: [],
          },
        ],
      };
    }
    const steps = await getPathwayStepsByIds(token, filter.value);
    return {
      field: filter.name,
      operator: 'any in',
      value: [{ value: steps, errors: [] }],
    };
  },
};
